// @flow
import React, { Component } from "react";

import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";

import UserItem from "../../containers/users/UserItemRedux";

type UserListPropsType = {
  users: Array<*>,
  isAdmin?: boolean,
  companyId?: string,
  facebaseId?: string,
  openSnackbar?: Function
};

class UserList extends Component<UserListPropsType, *> {
  render(): * {
    const users = this.props.users;
    const list =
      users &&
      users.map(
        (user: *, i: number): * => {
          return (
            <UserItem
              key={"user" + i}
              user={user}
              isAdmin={this.props.isAdmin}
              companyId={this.props.companyId}
              facebaseId={this.props.facebaseId}
              openSnackbar={this.props.openSnackbar}
            />
          );
        }
      );
    return (
      <div className="app-panel-content panel-top-margin">
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <List component="nav">
              <Divider light />
              {list}
            </List>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default UserList;
